import React, {useState} from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import {InstanceContext} from '../../../../InstanceContext';
import {UserContext} from '../../../../Context/UserContext';


const CommentForm = props => {
  const [comment, setComment] = useState(props.data.comment || '');
  const {user} = React.useContext(UserContext);

  const {contextInstance} = React.useContext(InstanceContext)
  const trialInstance = contextInstance || user.instance;

  const handleInput = e => setComment(e.target.value);
  const handleSubmit = e => {
    e.preventDefault();
    const {name, email, id} = user;
    const userData = {
      name: name,
      email: email,
      id: id,
      instance: trialInstance,
    }
    const postData = {
      comment: comment,
      exclude: props.exclude ? 'Yes' : 'No',
      instance: trialInstance,
      nct: props.data.nct_number,
      user: userData,
      title: props.data.title
    }
    props.handlePostEvent(postData);
  }

  return(
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleSubmit}>
        {props.exclude &&
          <label style={styles.label}>Comments:
            <textarea
              style={styles.textArea}
              onChange={handleInput}
              value={comment}
              name='comment'
              id='comment-text'
            />
          </label>
        }
        <Button
          styles={styles.submit}
          hoverStyles={styles.submitHov}
          activeStyles={styles.submitAct}
          focustStyles={styles.submitFoc}
          type='submit'
        >
          Save Changes
        </Button>
      </form>
    </div>
  )
}

export default CommentForm;
